import React from 'react'
import {useTranslation} from '@lib/intl/useTranslations'

import useLogin from '@hook/useLogin'
import useDark from '@hook/useDark'

import Text from '@component/Text/Text'
import TagText from '@component/Text/TagText'
import WizTooltip from '@component/tooltip/WizTooltip'
import ThreeColorStack from '@feature/portfolio/components/ThreeColorStack/ThreeColorStack'
import {TableHeaderContainer} from '@component/tables/TableHeaderContainer'

import IconInfoDark from '@svg/common/ic_info_dark.svg'
import Info from '@svg/common/ic_info.svg'

interface IProps {
    className?: string
    isFilterFavorite?: boolean
}

const LeaderboardHeaderContainer: React.FC<IProps> = ({className, isFilterFavorite}) => {
    const t = useTranslation()
    const {isLogin} = useLogin()
    const {isRenderDark} = useDark()

    return (
        <TableHeaderContainer
            className={`grid ${
                isLogin() === true
                    ? isFilterFavorite
                        ? 'grid-cols-[24px_400px_1fr_1fr_1fr_1fr_162px] md:grid-cols-[auto_100px]'
                        : 'grid-cols-[24px_50px_400px_1fr_1fr_1fr_1fr_162px] md:grid-cols-[auto_100px]'
                    : 'grid-cols-[50px_400px_1fr_1fr_1fr_1fr_162px] md:grid-cols-[35px_auto_64px]'
            } gap-x-[10px] md:gap-x-[5px] my-[10px] md:px-[10px]`}>
            {isLogin() === true && <div className={'md:hidden'} />}
            {!isFilterFavorite && (
                <Text
                    className={`text-ti2 text-gray02 dark:text-dark_gray02 text-center md:text-left md:text-ti3 ${
                        isLogin() === true && 'md:hidden'
                    }`}>
                    {t('leaderboard.table.title.rank')}
                </Text>
            )}
            <Text className="text-ti2 text-gray02 dark:text-dark_gray02 md:text-ti3">
                {t('leaderboard.table.title.copyleader')}
            </Text>
            <Text className="text-ti2 text-gray02 dark:text-dark_gray02 md:hidden">
                {t('leaderboard.table.title.exchange')}
            </Text>
            {/*<Text className="text-ti2 text-gray02 dark:text-dark_gray02 md:hidden">{t('leaderboard.table.title.copiers')}</Text>*/}
            <Text className="text-ti2 text-gray02 dark:text-dark_gray02 text-right md:hidden">
                {t('leaderboard.table.title.aum')}
            </Text>
            <Text className="text-ti2 text-gray02 dark:text-dark_gray02 text-right md:text-right md:text-ti3">
                {t('leaderboard.table.title.profit')}
            </Text>
            <div className={'flex items-center gap-x-[5px] justify-center md:hidden'}>
                <Text className=" text-ti2 text-gray02 dark:text-dark_gray02 text-center">
                    {t('leaderboard.table.title.risk_level')}
                </Text>
                <WizTooltip
                    type={'key_leaderfolio_expected_income'}
                    title={t('balanceHeader.stats.riskLevel.tooltip.title')}
                    panelClassName={'max-w-[380px] sm:max-w-[340px]'}
                    render={
                        isRenderDark ? (
                            <IconInfoDark className={'w-[20px] fill-bg_dark_white03 hover:fill-bg_dark_white01'} />
                        ) : (
                            <Info className={'w-[20px] fill-white hover:fill-gray08'} />
                        )
                    }>
                    <TagText className={'text-body3 text-gray02 dark:text-dark_gray02 mt-[5px]'}>
                        {t('balanceHeader.stats.riskLevel.tooltip.desc')}
                    </TagText>
                    <div className={'pt-[10px] flex items-center justify-between'}>
                        <div className={'flex items-center'}>
                            <Text className={'text-body_comm text-gray02 dark:text-dark_gray02'}>
                                {t('balanceHeader.stats.riskLevel.accuracy.low')}
                            </Text>
                            <Text className={'text-body3 text-gray02 dark:text-dark_gray02 pl-[10px] pr-[4px]'}>
                                {t('balanceHeader.stats.riskLevel.accuracy')}
                            </Text>
                            <ThreeColorStack charge_low={true} color_low={'bg-primary dark:bg-dark_primary'} />
                        </div>
                        <div className={'flex items-center'}>
                            <Text className={'text-body_comm text-gray02 dark:text-dark_gray02'}>
                                {t('balanceHeader.stats.riskLevel.accuracy.moderate')}
                            </Text>
                            <Text className={'text-body3 text-gray02 dark:text-dark_gray02 pl-[10px] pr-[4px]'}>
                                {t('balanceHeader.stats.riskLevel.accuracy')}
                            </Text>
                            <ThreeColorStack charge_fair={true} color_fair={'bg-yellow dark:bg-dark_yellow'} />
                        </div>

                        <div className={'flex items-center'}>
                            <Text className={'text-body_comm text-gray02 dark:text-dark_gray02'}>
                                {t('balanceHeader.stats.riskLevel.accuracy.high')}
                            </Text>
                            <Text className={'text-body3 text-gray02 dark:text-dark_gray02 pl-[10px] pr-[4px]'}>
                                {t('balanceHeader.stats.riskLevel.accuracy')}
                            </Text>
                            <ThreeColorStack
                                charge_fair={true}
                                charge_high={true}
                                color_fair={'bg-yellow dark:bg-dark_yellow'}
                                color_high={'bg-red dark:bg-dark_red'}
                            />
                        </div>
                    </div>
                </WizTooltip>
            </div>
            <div className={'block md:hidden'} />
        </TableHeaderContainer>
    )
}
export default React.memo(LeaderboardHeaderContainer)
